import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Config, WebUrls as urls } from "../utills/config";

export const TelegramBackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const pathname = location.pathname;
    const fromStartApp = location.state?.fromStartApp === true;

    useEffect(() => {
        const backButton = Config.tgWindow?.BackButton;

        if (!backButton) return;

        const mainPages = [
            urls.UserPage,
            urls.BASE_URL,
            urls.LoginPage
        ];

        const isMainPage = mainPages.includes(pathname);

        if (isMainPage) {
            backButton.hide();
            return;
        }

        const handleBack = () => {
            if (fromStartApp) {
                navigate(urls.BASE_URL, { replace: true });
            } else {
                navigate(-1);
            }
        };

        backButton.show();
        backButton.onClick(handleBack);

        return () => {
            backButton.offClick(handleBack);
            backButton.hide();
        };
    }, [pathname, fromStartApp, navigate]);

    return null;
};